// src/utils/audit.js
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

/**
 * Central audit log writer.
 * Writes to: orgs/{orgId}/auditLogs/{logId}
 */
export async function logAudit(db, actor, payload) {
  try {
    const orgId = actor?.orgId || payload?.orgId;
    if (!orgId) return;

    const base = {
      ts: serverTimestamp(),
      action: payload?.action || 'UNKNOWN',
      page: payload?.page || '',
      entityType: payload?.entityType || '',
      entityId: payload?.entityId || '',
      entityName: payload?.entityName || '',
      storeId: payload?.storeId || '',
      performedByUid: actor?.uid || payload?.performedByUid || '',
      performedByName: actor?.name || payload?.performedByName || '',
      performedByEmail: actor?.email || payload?.performedByEmail || '',
    };

    const docBody = {
      ...base,
      ...(payload?.before !== undefined ? { before: payload.before } : {}),
      ...(payload?.after !== undefined ? { after: payload.after } : {}),
      ...(payload?.meta !== undefined ? { meta: payload.meta } : {}),
    };

    await addDoc(collection(db, 'orgs', orgId, 'auditLogs'), docBody);
  } catch {
    // never block the UI on audit log failures
  }
}
